// config.js
// development 测试环境, production 生产环境，根据环境变量选择配置
// const env = 'production';

// const dev = {
//   apiUrl: 'http://47.120.2.9:8100/prod-api',
// };

// const prod = {
//   apiUrl: 'http://47.120.2.9/prod-api',
// };

const config = {
  // development: dev,
  // production: prod,
  apiUrl: process.env.VUE_APP_BASE_API || 'http://47.120.2.9/prod-api',
};

module.exports = config;